<template>
	<div class="ComponentCardSkeleton">
		<v-card flat class="card" color="transparent">
			<div class="d-flex align-center img-container" style="height: 70%; background: #f5f5f5 !important; border-top-left-radius: 10px !important; border-top-right-radius: 10px !important;">
				<v-skeleton-loader type="avatar" :height="imgSize" :width="imgSize" class="mx-auto"/>
			</div>
			<div class="title d-flex align-center justify-center px-1 text-center label" style="height: 30%;">
				<v-skeleton-loader type="text" width="80%" class="mx-auto"/>
			</div>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'ComponentCardSkeleton',
	computed: {
		imgSize () {
			switch (this.$vuetify.display.name) {
				case 'xs': return 50
				case 'sm': return 60
				case 'md': return 70
				case 'lg': return 80
				case 'xl': return 80
				default: return 100
			}
		}
	}
}
</script>

<style scoped>
.ComponentCardSkeleton { width: 100%; height: 100%; box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.3); border-radius: 10px; }
.card { height: 100%; width: 100%; }
.label {
	width: 100% !important;
	background-color: white !important;
	border-bottom-left-radius: 10px !important;
	border-bottom-right-radius: 10px !important;
}
</style>

